import { render } from "./AddEmployeeCheckinPage.vue?vue&type=template&id=0261e1fb&ts=true"
import script from "./AddEmployeeCheckinPage.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeCheckinPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__